/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Link } from "react-router-dom";

import {
  BarChart, Bar, Cell, ResponsiveContainer,
} from 'recharts';
import TrendingUpIcon from 'mdi-react/TrendingUpIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const data = [
  { name: 'Page A', pv: 5 },
  { name: 'Page B', pv: 4 },
  { name: 'Page C', pv: 1 },
  { name: 'Page D', pv: 2 },
  { name: 'Page E', pv: 5 },
  { name: 'Page F', pv: 4 },
  { name: 'Page G', pv: 5 },
  { name: 'Page H', pv: 2 },
  { name: 'Page I', pv: 5 },
  { name: 'Page J', pv: 3 },
];

class Subscriptions extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      activeIndex: 0,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = (item) => {
    const index = data.indexOf(item.payload);
    this.setState({
      activeIndex: index,
    });
  };

  render() {
    const { activeIndex } = this.state;
    const activeItem = data[activeIndex];
    const { t } = this.props;

    return (
      <Col md={12} xl={3} lg={6} xs={12}>
        <Card>
          <CardBody className="dashboard__card-widget">
          <Link to={`/buildings`}>
            <div className="card__title">
              <h5 className="bold-text">{`New Buildings`} <span className="small-text light-text">(30 Days)</span></h5>
            </div>
          </Link>
            <div className="dashboard__total">
              {/*<TrendingUpIcon className="dashboard__trend-icon" />*/}
              <p className="dashboard__total-stat">
                {(activeItem.pv)}
                <div className="small-text light-text">Buildings</div>
              </p>
              <div className="dashboard__chart-container">
                <ResponsiveContainer height={140}>
                  <BarChart data={data}>
                    <Bar dataKey="pv" onClick={this.handleClick}>
                      {
                        data.map((entry, index) => (
                          <Cell
                            cursor="pointer"
                            fill={index === activeIndex ? '#780F9E' : '#D6BAE8'}
                            key={`cell-${index}`}
                          />
                        ))
                      }
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(Subscriptions);
